import { AlertCircle, Layers3, LoaderCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ICON_SIZE } from '../design-system';

const STATE_ICONS = {
  loading: LoaderCircle,
  empty: Layers3,
  error: AlertCircle,
};

const UniverseState = ({
  kind,
  title,
  description,
  actionLabel,
  onAction,
}) => {
  const { t } = useTranslation('reader');
  const Icon = STATE_ICONS[kind];

  if (!Icon) {
    throw new Error(`UniverseState does not support kind "${kind}".`);
  }

  const resolvedTitle = title || t(`universe.state.${kind}`);

  return (
    <div
      className={`universe-state universe-state--${kind}`}
      role={kind === 'error' ? 'alert' : 'status'}
      aria-live={kind === 'loading' ? 'polite' : undefined}
    >
      <Icon className="universe-state__icon" size={ICON_SIZE.xl} aria-hidden="true" />
      <h2 className="universe-state__title">{resolvedTitle}</h2>
      {description && <p className="universe-state__description">{description}</p>}
      {actionLabel && onAction && (
        <button type="button" className="universe-state__action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default UniverseState;
